
<div class="col-sm-6 col-md-4" style="width: 100%;">
    <div class="gallery-preview">
        <div class="img-block">
            <img [src]="(isImageUrl) ? imageUrl :'data:image/jpeg;base64,' + imageUrl" alt="Image" loading="lazy">
        </div>
        <div class="cta" *ngIf="showButtons">
            <app-button [btnText]="'Edit'" [btnTitle]="'Edit'" [btnCss]="'btn btn-primary'" (onBtnClick)="editPhoto()"></app-button>
            <app-button [btnText]="'Delete'" [btnTitle]="'Delete'" [btnCss]="'btn btn-primary'"  (onBtnClick)="onDelete()"></app-button>
        </div>
    </div>
</div>
